// Deterministic, fully client-side session fixtures for DEV Mock Auth. These are never sourced
// from a backend: there is no session-listing endpoint in the current OpenAPI contract, so this
// data exists only to demonstrate the Profile surface and must stay clearly labeled as Mock Data.

export interface MockSession {
  readonly id: string;
  readonly device: string;
  readonly location: string;
  readonly ipAddress: string;
  readonly signedInAt: string;
  readonly lastActiveAt: string;
  readonly current: boolean;
}

export const mockActiveSessions: readonly MockSession[] = Object.freeze([
  Object.freeze({
    id: '00000000-0000-4000-8000-000000009101',
    device: 'Current browser · Chrome on macOS',
    location: 'Bangkok, TH',
    ipAddress: '203.0.113.10',
    signedInAt: '2026-07-24T08:00:00+07:00',
    lastActiveAt: '2026-07-24T09:30:00+07:00',
    current: true,
  }),
  Object.freeze({
    id: '00000000-0000-4000-8000-000000009102',
    device: 'Mobile app · iOS',
    location: 'Bangkok, TH',
    ipAddress: '203.0.113.24',
    signedInAt: '2026-07-20T18:00:00+07:00',
    lastActiveAt: '2026-07-23T21:15:00+07:00',
    current: false,
  }),
  Object.freeze({
    id: '00000000-0000-4000-8000-000000009103',
    device: 'Desktop app · Windows',
    location: 'Chiang Mai, TH',
    ipAddress: '203.0.113.55',
    signedInAt: '2026-07-18T09:00:00+07:00',
    lastActiveAt: '2026-07-22T17:45:00+07:00',
    current: false,
  }),
]);
